module.exports = __webpack_public_path__ + "img/arrow-circle-right.4eef2bbd.svg";